import API from './resources'

const actions = {
  async allLogs({ commit, state }, payload) {
    try {
      if (payload.email === undefined) {
        const response = await API.allLogs(
          state.current_page,
          state.page_size,
          // state.email,
          payload.token
        )

        commit('SET_PUSH_LIST', response)
        return response
      } else {
        const response = await API.filterLogs(
          state.current_page,
          state.page_size,
          state.email,
          state.search_message,
          payload.token
        )
        commit('SET_PUSH_LIST', response)
        return response
      }
    } catch (error) {
      return error
    }
  },
  async allPushWebSchedules({ commit, state }, payload) {

    try {
      const response = await API.allPushWebSchedules(
        state.current_page,
        state.page_size,
        payload.search,
        payload.token
      )

      commit('SET_PUSH_LIST', response)
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async cancelScheddule({}, payload) {
    const {token, id, csvName} = payload;

    try {
      const response = await API.cancelScheddule({ csv_name: csvName }, token)
      
      return response
    } catch (error) {
      return error
    }
  },
  async getAllowedsToCancel({ commit, state }, token){
    try {
      
      const response = await API.getAllowedsToCancel(token)

      commit('SET_ALLOWED_TO_CANCEL', response)
      return response.data
    } catch (error) {
      return error
    }
  },
  async allPushWebLogs({ commit, state }, payload) {
    try {
      commit('SET_PUSHLOGS_LIST', [])

      const response = await API.allLogs(
        state.current_page,
        state.page_size ,
        payload.search,
        payload.token
        )
        
        commit('SET_PUSHLOGS_LIST', response)
      return response;
    } catch (error) {
      console.error(error);
    }
  },

  async getService({ commit }, payload) {
    try {
      const response = await API.getServices(
        payload.token
      )
      commit('SET_SERVICE', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async updateMessage(_, payload) {
    let data, token
    [data, token] = payload
    try {
      const response = await API.updateMessages(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postNewPushWeb(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postPush(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postPushWebTeste(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postTestePush(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async getDetailsPushWeb({ commit }, payload) {
    let [data, token] = payload

    try {
  
      const response = await API.getLogsPushDetails(
       data, token
      )
  
      commit('SET_USER_ID', response)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/push_web_logs/actions.js